import type { ApplicationFormDefinition } from '../types/applicationForm';

export type FormModuleCategory = 'finance' | 'customer-services' | 'admin' | 'purchasing';

export type FormModule = {
  slug: string;
  label: string;
  icon: string;
  title: string;
  description: string;
  category: FormModuleCategory;
};

export const FORM_MODULE_CATEGORIES: {
  id: FormModuleCategory;
  label: string;
}[] = [
  { id: 'finance', label: 'Finance' },
  { id: 'customer-services', label: 'Customer Services' },
  { id: 'admin', label: 'Admin' },
  { id: 'purchasing', label: 'Purchasing' },
];

export const FORM_MODULES: FormModule[] = [
  {
    slug: 'account-creation',
    label: 'Account Creation',
    icon: '📝',
    title: 'Account Creation',
    description: 'New customer or outlet application.',
    category: 'finance',
  },
  {
    slug: 'customer-feedback',
    label: 'Customer Feedback Form (CFF)',
    icon: '📋',
    title: 'Customer Feedback Form (CFF)',
    description: 'Warehouse / Logistics feedback.',
    category: 'customer-services',
  },
  {
    slug: 'internal-memo',
    label: 'Internal Memorandum',
    icon: '📄',
    title: 'Internal Memorandum',
    description: 'Internal memorandum.',
    category: 'admin',
  },
  {
    slug: 'pricing-update',
    label: 'Pricing Update',
    icon: '💹',
    title: 'Pricing Update',
    description: 'Price update request (PUF) — requestor / authorised / approver.',
    category: 'admin',
  },
  {
    slug: 'certificate-request',
    label: 'Certificate Request',
    icon: '📜',
    title: 'Certificate Request',
    description: 'Certificate request (PU-040) — requestor / authorised / approver.',
    category: 'admin',
  },
  {
    slug: 'customise-items-transfer',
    label: 'Sales Confirmation',
    icon: '📦',
    title: 'Sales Confirmation',
    description: 'Sales confirmation, deposit / tooling invoices and stock transfer.',
    category: 'purchasing',
  },
];

export const FORMS_DEFAULT_SLUG = 'account-creation';

export function formModuleBySlug(slug: string): FormModule | undefined {
  return FORM_MODULES.find((mod) => mod.slug === slug);
}

export function formModulesByCategory(category: FormModuleCategory): FormModule[] {
  return FORM_MODULES.filter((mod) => mod.category === category);
}

export type FormDefinitionRow = ApplicationFormDefinition;
